import { CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';

/**
 * Create a type which requires the Fallback to be set
 * but make all the other enums optional.
 **/
type CountryCodesWithUKRecords = Record<
  CountryCodes.GB,
  (publicId: string, cleanedName: string) => string
> &
  Partial<Record<CountryCodes, (publicId: string, cleanedName: string) => string>>;

const localeToForm: CountryCodesWithUKRecords = {
  [CountryCodes.GB]: (publicId: string, cleanedName: string) =>
    `1_Z7Yo4fomPByCnI5SdmvyZwhRYZL1HyfHVIMkVIbtUA/viewform?entry.1020357355&entry.796151679=${cleanedName}&entry.1868286089&entry.802368912&entry.1633925015=${publicId}`,
  [CountryCodes.DE]: (publicId: string, cleanedName: string) =>
    `1lYORYA1nGilEmEuOqy5vB7kH0Oav2be-Re6dnOPnQ38/viewform?entry.796151679=${cleanedName}&entry.1633925015=${publicId}`,
  [CountryCodes.FR]: (publicId: string, cleanedName: string) =>
    `e/1FAIpQLScezxwsuC81t4OGdggtbDLtrHz6lD_kelCoL36Ym_2MuVchvQ/viewform?entry.1380293704=${cleanedName}&entry.2044959358=${publicId}`,
  [CountryCodes.IE]: (publicId: string, cleanedName: string) =>
    `1_Z7Yo4fomPByCnI5SdmvyZwhRYZL1HyfHVIMkVIbtUA/viewform?entry.1020357355&entry.796151679=${cleanedName}&entry.1868286089&entry.802368912&entry.1633925015=${publicId}`,
  [CountryCodes.PL]: (publicId: string, cleanedName: string) =>
    `e/1FAIpQLScCB8NclHD2Ztd11ZBpvcbF7I22ehu7Jt4J9OxEVGAXHJVaHw/viewform?entry.1020357355&entry.796151679=${cleanedName}&entry.1868286089&entry.802368912&entry.1633925015=${publicId}`,
  [CountryCodes.AT]: (publicId: string, cleanedName: string) =>
    `e/1FAIpQLSd74ZhIeaskaXdB3uSQjrE2kvjYCmrUlWsR837fcqoSA7NAtg/viewform?entry.1020357355&entry.796151679=${cleanedName}&entry.1868286089&entry.802368912&entry.1633925015=${publicId}`,
  [CountryCodes.CH]: (publicId: string, cleanedName: string) =>
    `e/1FAIpQLSd74ZhIeaskaXdB3uSQjrE2kvjYCmrUlWsR837fcqoSA7NAtg/viewform?entry.1020357355&entry.796151679=${cleanedName}&entry.1868286089&entry.802368912&entry.1633925015=${publicId}`,
};

export const getUnverifiedLink = ({
  market,
  cleanedName,
  publicId,
}: {
  market: Market;
  cleanedName: string;
  publicId: string;
}): string => {
  const form = localeToForm[market.country] || localeToForm[CountryCodes.GB];

  return 'https://docs.google.com/forms/d/' + form(publicId, cleanedName);
};
